import {useState} from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard} from '../../../../_metronic/helpers'
import {PartnersListHeader} from './componente/PartnersListHeader'
import {PartnersTable} from './componente/PartnersTable'
import {
  Field,
  initialProcessFiles,
  Proceso,
  ProcessFiles,
  ProcessSheet,
  Section,
  Sheet,
} from './documentInterface'
import {EntityTagsModal} from './entity-tags/EntityTagsModal'
import {PartnerContext} from './PartnerContexts'
import {TagsEditModal} from './show-search-tag-modal/TagsEditModal'

const fichasBreadcrumbs = [
  {
    title: 'Configuración',
    path: '/seguimiento/documentos',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export default function FichasPage() {
  const [searchTerm, setSearchTerm] = useState('')
  const [searchDocument, setSearchDocument] = useState('')
  const [process_id, setProcessId] = useState('')
  const [procesoData, setProcesoData] = useState<Proceso>({
    _id: '',
    nombre: '',
    codigo: '',
    descripcion: '',
    estado: '',
  })
  const [isTagsModalOpen, setTagsModalStatus] = useState(false)
  const [isEditFileModalOpen, setIsEditFileModalOpen] = useState(false)
  const [updateFile, setUpdateFile] = useState(false)
  const [processSheetData, setProcessSheetData] = useState<ProcessSheet[]>([])
  const [sheetData, setSheetData] = useState<Sheet[]>([])
  const [sectionData, setSectionData] = useState<Section[]>([])
  const [fieldData, setFieldData] = useState<Field[]>([])
  const [fileData, setFileData] = useState<ProcessFiles>(initialProcessFiles)
  const [documents, setDocuments] = useState<{}>({})
  const [documentsAux, setDocumentsAux] = useState<{}>({})
  const [entityTagsModalOpen, setEntityTagsModalOpen] = useState(false)

  const openTagsModal = () => {
    setTagsModalStatus(true)
  }

  const closeTagsModal = () => {
    setTagsModalStatus(false)
  }

  const openEditFileModal = () => {
    setIsEditFileModalOpen(true)
  }

  const closeEditFileModal = () => {
    setIsEditFileModalOpen(false)
  }

  const openEntityTagsModal = () => {
    setEntityTagsModalOpen(true)
  }

  const closeEntityTagsModal = () => {
    setEntityTagsModalOpen(false)
  }

  const valueContext = {
    searchTerm,
    setSearchTerm,
    searchDocument,
    setSearchDocument,
    process_id,
    setProcessId,
    procesoData,
    setProcesoData,
    processSheetData,
    setProcessSheetData,
    sheetData,
    setSheetData,
    sectionData,
    setSectionData,
    fieldData,
    setFieldData,
    isTagsModalOpen,
    openTagsModal,
    closeTagsModal,
    fileData,
    setFileData,
    isEditFileModalOpen,
    openEditFileModal,
    closeEditFileModal,
    updateFile,
    setUpdateFile,
    documents,
    setDocuments,
    documentsAux,
    setDocumentsAux,
    entityTagsModalOpen,
    openEntityTagsModal,
    closeEntityTagsModal,
  }
  return (
    <>
      <PartnerContext.Provider value={valueContext}>
        <BasicBreadcrumbs breadcrumbs={fichasBreadcrumbs} fallbackTitle='Documentos' />
        <KTCard>
          <PartnersListHeader />
          <PartnersTable />
        </KTCard>
        <TagsEditModal />

        {entityTagsModalOpen && <EntityTagsModal />}
      </PartnerContext.Provider>
    </>
  )
}
